<style>
    /*
   * Die Kapitelnummern stehen bereits im Text der &Uuml;berschriften.
   * Dadurch wird eine zus&auml;tzliche Nummerierung aus globalen CSS-Regeln verhindert.
   */
    .ktbl-help h2,
    .ktbl-help h3,
    .ktbl-help h4 {
        counter-increment: none !important;
    }

    .ktbl-help h2::before,
    .ktbl-help h3::before,
    .ktbl-help h4::before {
        content: none !important;
        display: none !important;
    }

    .ktbl-help [id] {
        scroll-margin-top: 6rem;
    }

    .ktbl-help-toc {
        margin: 1.5rem 0 2rem;
    }

    .ktbl-help-toc ul {
        margin: 0.35rem 0;
        padding-left: 1.5rem;
    }

    .ktbl-help-toc>ul {
        padding-left: 1.25rem;
    }

    .ktbl-help-toc li {
        margin: 0.3rem 0;
    }

    .ktbl-help-toc a {
        white-space: normal !important;
        overflow-wrap: anywhere;
    }

    /* Keine Aufz&auml;hlungszeichen im Inhaltsverzeichnis */
    .ktbl-help .ktbl-help-toc ul,
    .ktbl-help .ktbl-help-toc ol,
    .ktbl-help .ktbl-help-toc li {
        list-style: none !important;
    }

    .ktbl-help .ktbl-help-toc>ul {
        margin-left: 0 !important;
        padding-left: 0 !important;
    }

    .ktbl-help .ktbl-help-toc ul ul {
        margin-left: 0 !important;
        padding-left: 1.5rem !important;
    }

    .ktbl-help .ktbl-help-toc li::marker {
        content: "" !important;
        font-size: 0 !important;
    }

    .ktbl-help .ktbl-help-toc li::before {
        content: none !important;
        display: none !important;
    }
</style>
<div class="ktbl-spacer-top-bottom"></div>

<div class="ktbl-container">
    <article class="ktbl-help">
        <h1>
            Über BauKost
        </h1>

        <h2 id="inhaltsverzeichnis">
            Inhaltsverzeichnis
        </h2>

        <nav aria-labelledby="inhaltsverzeichnis" class="ktbl-help-toc">
            <ul>
                <li>
                    <a href="ueber-baukost#was-ist-baukost">
                        Was ist BauKost?
                    </a>
                </li>
                <li>
                    <a href="ueber-baukost#welche-ergebnisse-liefert-baukost">
                        Welche Ergebnisse liefert BauKost?
                    </a>
                </li>
                <li>
                    <a href="ueber-baukost#wie-wird-der-investitionsbedarf-ermittelt">
                        Wie wird der Investitionsbedarf ermittelt?
                    </a>
                </li>
                <li>
                    <a href="ueber-baukost#wie-werden-die-jaehrlichen-gebaeudekosten-berechnet">
                        Wie werden die jährlichen Gebäudekosten berechnet?
                    </a>
                </li>
                <li>
                    <a href="ueber-baukost#wie-koennen-die-kosten-angepasst-werden">
                        Wie können die Kosten angepasst werden?
                    </a>
                </li>
                <li>
                    <a href="ueber-baukost#wie-koennen-die-kosten-beurteilt-werden">
                        Wie können die Kosten beurteilt werden?
                    </a>
                </li>
                <li>
                    <a href="ueber-baukost#welche-weiteren-informationsquellen-gibt-es">
                        Welche weiteren Informationsquellen gibt es?
                    </a>
                </li>
                <li>
                    <a href="ueber-baukost#foerderhinweis">
                        Förderhinweis
                    </a>
                </li>
            </ul>
        </nav>


        <h2 id="was-ist-baukost">
            Was ist BauKost?
        </h2>

        <p>
            BauKost unterstützt Sie bei der Planung und Bewertung von
            landwirtschaftlichen Stallgebäuden und baulichen Anlagen. Die Anwendung ermöglicht
            den Vergleich von verschiedenen baulichen Modelllösungen anhand des Investitionsbedarfs
            sowie der jährlichen Gebäudekosten.
        </p>

        <p>
            Die in BauKost enthaltenen Modelle basieren auf Planungen, die von
            Fachleuten nach dem jeweils aktuellen Stand der Technik erstellt wurden. Jedes
            Modell ist durch Grundriss, Schnitt, Baubeschreibung und Planungskennzahlen
            dokumentiert.
        </p>

        <p>
            Die Baukosten wurden aus den Mengen und Einheitspreisen vergleichbarer,
            bereits ausgeführter Bauvorhaben abgeleitet. Grundlage sind Unternehmerpreise
            ohne Mehrwertsteuer und ohne die Erbringung von Eigenleistungen.
        </p>


        <h2 id="welche-ergebnisse-liefert-baukost">
            Welche Ergebnisse liefert BauKost?
        </h2>

        <p>
            BauKost stellt folgende Informationen zu den Modellen bereit:
        </p>

        <ol>
            <li>Investitionsbedarf</li>
            <li>jährliche Gebäudekosten</li>
            <li>Flächen- und Volumenkennzahlen</li>
            <li>
                Kostenkennwerte je Tierplatz oder je Bezugsgröße der Gebäudeklasse
            </li>
            <li>
                Kosten nach funktionsbezogener Gliederung in Kostenblöcken
            </li>
            <li>
                Kosten nach planungsorientierter Gliederung DIN 276
            </li>
        </ol>


        <h2 id="wie-wird-der-investitionsbedarf-ermittelt">
            Wie wird der Investitionsbedarf ermittelt?
        </h2>

        <p>
            Der Investitionsbedarf wird nach DIN 276 „Kosten im Bauwesen“ ermittelt und
            umfasst die Kostengruppen 300 „Bauwerk – Baukonstruktionen“, 400 „Bauwerk –
            Technische Anlagen“ und teilweise 500 „Außenanlagen und Freiflächen“ (z. B.
            Treibwege, Verladerampe, Kraftfuttersilos).
        </p>

        <p>
            Nicht enthalten sind der Investitionsbedarf für Grundstück, Erschließung
            und Baunebenkosten (Planungs- und Genehmigungskosten). Regionale
            Preisunterschiede sind ebenfalls nicht berücksichtigt.
        </p>


        <h2 id="wie-werden-die-jaehrlichen-gebaeudekosten-berechnet">
            Wie werden die jährlichen Gebäudekosten berechnet?
        </h2>

        <p>
            Die jährlichen Gebäudekosten sind die auf ein Jahr bezogenen Kosten eines
            Bauwerks während seiner Nutzungsdauer. In BauKost werden sie aus Abschreibung,
            Zinskosten, Unterhaltung und Versicherungskosten ermittelt.
        </p>

        <p>
            Die jährlichen Gebäudekosten werden als Gesamtsumme und je Bezugseinheit,
            z. B. je Tierplatz, ausgewiesen.
        </p>


        <h2 id="wie-koennen-die-kosten-angepasst-werden">
            Wie können die Kosten angepasst werden?
        </h2>

        <p>
            Alle Kosten in BauKost werden standardmäßig auf Grundlage des aktuellen
            Baupreisindex des Statistischen Bundesamtes für den Neubau gewerblicher
            Betriebsgebäude und ohne Mehrwertsteuer berechnet. Dadurch sind die Ergebnisse
            unterschiedlicher Modelle direkt miteinander vergleichbar.
        </p>

        <p>
            Der Preisstand kann in den Einstellungen auf den Baupreisindex früherer
            Jahre angepasst werden. Zusätzlich kann ein Preisfaktor verwendet werden, um
            beispielsweise:
        </p>

        <ul>
            <li>regionale Preisunterschiede,</li>
            <li>erwartete Preisentwicklungen oder</li>
            <li>die Mehrwertsteuer</li>
        </ul>

        <p>
            in den ausgewiesenen Werten zu berücksichtigen.
        </p>


        <h2 id="wie-koennen-die-kosten-beurteilt-werden">
            Wie können die Kosten beurteilt werden?
        </h2>

        <p>
            BauKost stellt je nach Gebäudeart oder Art der baulichen Anlage
            verschiedene Kennzahlen als Bezugseinheiten zur Beurteilung der Baukosten
            bereit:
        </p>

        <ol>
            <li>Tierplatz</li>
            <li>Nutzungsdauer</li>
            <li>Fläche</li>
            <li>Volumen</li>
            <li>Jahr</li>
            <li>Kostenelemente</li>
            <li>Kostenblöcke</li>
        </ol>

        <p>
            Die Grundflächen und Rauminhalte werden nach DIN 277 "Grundflächen und
            Rauminhalte von Bauwerken im Hochbau" berechnet.
        </p>


        <h2 id="welche-weiteren-informationsquellen-gibt-es">
            Welche weiteren Informationsquellen gibt es?
        </h2>

        <p>
            Weitere Informationen zu den Baukosten landwirtschaftlicher Gebäude finden Sie in:
        </p>

        <ul>
            <li>
                KTBL-Veröffentlichungen
                (<a href="https://www.ktbl.de/themen/datensammlungen">Datensammlungen</a>,
                <a
                    href="https://www.ktbl.de/fileadmin/user_upload/Allgemeines/Download/MiniFZ-Landwirtschaft.pdf">Faustzahlen</a>)
                sowie der Anwendung
                „<a href="https://www.ktbl.de/webanwendungen/baukost-gewaechshaeuser">BauKost
                    Gewächshäuser</a>“,
            </li>
            <li>
                der ALB-Hessen-Broschüre
                „<a href="https://www.alb-hessen.de/veroeffentlichungen/richtpreise.html">Richtpreise für den Neu- und
                    Umbau
                    landwirtschaftlicher Wirtschaftsgebäude und ländlicher Wohnhäuser</a>“,
            </li>
            <li>
                der Baukostendatenbank des BKI
                (Baukosteninformationszentrum Deutscher Architektenkammern), die auf
                ausgeführten und abgerechneten Objekten beruht,
            </li>
            <li>
                den Normalherstellungskosten (NHK) der Sachwertrichtlinie, die zuletzt als
                Anlage 1 der Sachwertrichtlinie im Bundesanzeiger Verlag veröffentlicht wurden.
            </li>
        </ul>


        <h2 id="foerderhinweis">
            Förderhinweis
        </h2>

        <p>
            Die Ermittlung von Daten zu den in BauKost enthaltenen Modellen werden im
            Rahmen des KTBL-Arbeitsprogramms „Kalkulationsunterlagen“ (AP KU) gefördert,
            das gemeinsam von Bund und Ländern finanziert wird.
        </p>
    </article>
</div>

<div class="ktbl-spacer-top-bottom"></div>




<div class="ktbl-floating-container-ohne-rand-wrapper">
    <div class="ktbl-floating-content">
        <button (click)="onClickUp()" class="ktbl-button-primaer ktbl-button-icon-l" mat-raised-button="" type="button">
            <i class="fas fa-chevron-up ktbl-icon-vertical-align">
            </i>
        </button>
        <button (click)="onClickDown()" class="ktbl-button-primaer ktbl-button-icon-l" mat-raised-button=""
            type="button">
            <i class="fas fa-chevron-down ktbl-icon-vertical-align">
            </i>
        </button>
    </div>
</div>